import { render, staticRenderFns } from "./pane-investigator.vue?vue&type=template&id=3a1b7de1&"
import script from "./pane-investigator.vue?vue&type=script&lang=js&"
export * from "./pane-investigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports